import React, { Component } from "react";
import './ConversationStyleSheet.css';
import Message from "./MessageBoxTypes/Message";
import { CircularProgress } from "@material-ui/core";

class Conversation extends Component {

    constructor(props) {
        super(props);
        this.conversationRef = React.createRef();
    }

    render() {
        const messages = this.props.messages || [];
        const isFetchingMessages = this.props.isFetchingMessages || false;
        return (
            <div ref={this.conversationRef} onScroll={this.onConversationScroll} className="s360-conversation">
                {isFetchingMessages && (<div className="s360-message-cotainer-activity-indicator" style={{ color: this.props.config.designDetails.headerColor || 'lightgray' }}>
                        <CircularProgress color="inherit" size={20} /> </div>)}
                {messages.map(message => <Message {...this.props} message={message} key={message.id} startNewConversation={this.props.startNewConversation} />)}
            </div>
        );
    }

    scrollToLatestMessage = () => {
        this.conversationRef.current.scrollTop = this.conversationRef.current.scrollHeight;
    }

    scrollToLastPosition = () => {
      this.conversationRef.current.scrollTop = Math.max(this.conversationRef.current.scrollHeight - this.lastScrollHeight, 0);
    }

    lastScrollHeight = 0;
    onConversationScroll = () => {
        let scrollContainer = this.conversationRef.current;
        this.lastScrollHeight = scrollContainer.scrollHeight;
        let isTop = scrollContainer.scrollTop === 0;
        if (isTop) {
            this.props.onScrollToConversationTop();
        }
    }
}

export default Conversation;